export class Signature {
    public expiresIn?: number;
    public token: string;
    public type: string;
    public scopes?: string;
}
